/*global angular*/

angular.module('clinkManager').controller('CLinkIDDecoder', ['$scope', 'AppHelper', 'ngDialog', '$uibModalInstance', '$q', function ($scope, AppHelper, ngDialog, $uibModalInstance, $q) {
	$scope.clink = {
			clinkID : null,
			appID : null,
			incent : null,
			payout : null,
			deviceID : null,
			platforms : null,
			createdDate : null,
			countries : null,
			message : null
		};
		
		$scope.cancel = function () {
		  	$uibModalInstance.dismiss('cancel');
	  	};
	  	
	  	$scope.decodeID = function() {
	  		$scope._decodeID().then( function() {} );
	  	};
	  	
	  	$scope._decodeID = function() {
			$scope.decodingID = true;
			var deferred = $q.defer();
			AppHelper.getDecodedAutoClinkID( {'clinkid':$scope.clink.clinkID},
				function( data ) {
					$scope.clink.clinkID = data['clinkID'];
					$scope.clink.appID = data['appID'];
					$scope.clink.incent = data['incent'];
					$scope.clink.payout = data['payout'];
					$scope.clink.deviceID = data['deviceID'];
					$scope.clink.platforms = data['platforms'];
					$scope.clink.createdDate = data['createdDate'];
					$scope.clink.countries = data['countries'];
					$scope.clink.message = data['message'];
				},
				function() {
					deferred.reject();
					$scope.message = 'Error decoding cLink ID';
					ngDialog.open({
						template: 'static/dialogs/error.html',
						scope: $scope
					});
				},
				function() {
					$scope.decodingID = false;
					deferred.resolve();
				}
			);
			return deferred.promise;
		};
		
	  	$scope.idDecoded = function() {
	  		if ( $scope.clink.appID ) {
	  			return true;
	  		}
	  	    return false;
	  	};	
}]);
